import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';

/**
* @author Camilo
* @since  23/11/2017
**/
@Component({
	selector : 'usuarios',
	templateUrl : './UsuariosIndex.component.html',
	styleUrls  : ['../../../../styles.css']
})
export class UsuariosIndexComponent{


	public listadoUsuarios:Array<opciones>;
	public listadoContrato:Array<opciones>;
	public cnumcont:string = "";
	public mensaje: string = "..";

	constructor(private formBuilder: FormBuilder, private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar, 
		private _route: ActivatedRoute, private _router:Router){

		this.listadoUsuarios = new Array();
		this.listadoContrato = new Array();
		this.snackBar.dismiss();

		_route.params.subscribe(params=>{
			
			this.cnumcont = params['cnumcont'];
			_serviciosGenerales.get('usuariosContrato', {cnumcont : params['cnumcont']}).subscribe(
				result=>{
					console.log(result);
					for(let x in result){
						this.listadoContrato.push(new opciones(false, result[x].cusuario));
					}
				}, error=>{
					this.openSnackBar('Ocurrió un error mientras se cargan los usuarios del contrato', 'X');
				});

			_serviciosGenerales.get('usuariosSis', {cnumcont : params['cnumcont']}).subscribe(
				result=>{
					console.log(result);
					for(let x in result){
						this.listadoUsuarios.push(new opciones(false, result[x].cusuario));
					}
				}, error=>{
					this.openSnackBar('Ocurrió un error mientras se cargan los usuarios del contrato', 'X');
				});

		})

	}

	public asignar(){
		
		for(let x = 0 ; x < this.listadoUsuarios.length ; x ++){

			if(this.listadoUsuarios[x].seleccion == true){
				this.openSnackBar('Guardando...', 'X');
				this._serviciosGenerales.post('guardar/usucont', {id : {cusuario : this.listadoUsuarios[x].usuario, cnumcont : this.cnumcont} }).subscribe(
					result=>{
						this.openSnackBar('Cambios Guardados Correctamente', 'X');
						this.listadoUsuarios[x].seleccion = false;
						this.listadoContrato.push(this.listadoUsuarios[x]);
						this.listadoUsuarios.splice(x, 1);
					}, error=>{
						this.openSnackBar('Ocurrió un error mientras se cargan los usuarios del contrato', 'X');
					});

				
			}
		}
	}


	public descartar(){
		
		for(let x = 0 ; x < this.listadoContrato.length ; x ++){
			
			if(this.listadoContrato[x].seleccion == true){
				this.openSnackBar('Guardando...', 'X');

				this._serviciosGenerales.delete('eliminarUsuarioUsucont', {cusuario : this.listadoContrato[x].usuario, cnumcont : this.cnumcont} ).subscribe(
					result=>{
						this.openSnackBar('Cambios Guardados Correctamente', 'X');
						this.listadoContrato[x].seleccion == false;
						this.listadoUsuarios.push(this.listadoContrato[x]);
						this.listadoContrato.splice(x, 1);
					}, error=>{
						this.openSnackBar('Ocurrió un error mientras se cargan los usuarios del contrato', 'X');
					});

			}
			
		}
	}

	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}
}

export class opciones{
	constructor(public seleccion:boolean , public usuario:string){

	}
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Usuarios/UsuariosIndex.component.ts